import type { Location } from 'history'
import { useFormContext } from './use-form-context'
import { shouldSkipConfirmation } from './util'
import { BaseNavigationGuards } from './BaseNavigationGuards'
import { ActionBeforeLogout, BaseDialogVersion } from './BaseNavigationConfirmation'

interface Props {
  handleShopChange?: (shopId: string) => Promise<void>
  handleLogout?: (orderAction: `${ActionBeforeLogout}`) => Promise<void>
  isPortal?: boolean
}

export function DefaultNavigationConfirmation({ handleShopChange, handleLogout, isPortal = false }: Props) {
  const form = useFormContext()
  const defaultRouteWhen = (currentLocation: Location, nextLocation?: Location): boolean => {
    if (nextLocation && shouldSkipConfirmation(nextLocation)) {
      return false
    }
    return currentLocation.pathname !== nextLocation?.pathname && form.dirty
  }

  return (
    <BaseNavigationGuards
      baseDialogVersion={BaseDialogVersion.MuiUi}
      when={defaultRouteWhen}
      validateBeforeNavigate={async () => form.validateForm()}
      saveBeforeNavigate={async () => {
        await form.submitForm()
      }}
      handleShopChange={handleShopChange}
      handleLogout={handleLogout}
      isPortal={isPortal}
    />
  )
}
